module.exports = __webpack_public_path__ + "static/azure-native-vms-fb865c29ac7cf0f3ba1a4af1dcc6b293.png";